(function () {
  var root = null;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function el(html) { var d = document.createElement('div'); d.innerHTML = html; return d.firstChild; }
  function legendName(lg) {
    var c = lg.cloneNode(true);
    $$('.zoq-pp-sizelinks,.zoq-pp-selected', c).forEach(function (n) { n.remove(); });
    return c.textContent.trim().toLowerCase();
  }
  function sizeFieldset() {
    var fs = $$('variant-picker fieldset');
    for (var i = 0; i < fs.length; i++) {
      var lg = $('legend', fs[i]);
      var t = lg ? legendName(lg) : '';
      if (/size/.test(t) && !/fit/.test(t)) return fs[i];
    }
    return null;
  }
  function radios(fs) { return $$('input[type="radio"]', fs); }

  function ensureSelectedLabels() {
    $$('variant-picker fieldset').forEach(function (fs) {
      var lg = $('legend', fs);
      if (!lg || /fit/.test(legendName(lg))) return;
      var span = $('.zoq-pp-selected', lg);
      if (!span) {
        span = document.createElement('span');
        span.className = 'zoq-pp-selected';
        lg.insertBefore(span, $('.zoq-pp-sizelinks', lg) || null);
      }
      var c = fs.querySelector('input[type="radio"]:checked');
      var txt = c ? ': ' + c.value : '';
      if (span.textContent !== txt) span.textContent = txt;
    });
  }

  function ensureRecommended() {
    var fs = sizeFieldset();
    if (!fs) return;
    var sizes = (root.getAttribute('data-ready-sizes') || '').split('|').filter(Boolean);
    var tag = root.getAttribute('data-ready-label') || 'Popular';
    if (!sizes.length) return;
    radios(fs).forEach(function (r) {
      var lab = r.closest('label');
      if (lab && sizes.indexOf(r.value) !== -1 && !lab.classList.contains('zoq-pp-recommended')) { lab.classList.add('zoq-pp-recommended'); lab.setAttribute('data-zoq-tag', tag); }
    });
  }

  function parseTable(text) {
    if (!text) return null;
    var lines = text.split(/\n/).map(function (l) { return l.trim(); }).filter(Boolean);
    if (lines.length < 2) return null;
    var split = function (l) { return l.split('|').map(function (c) { return c.trim(); }); };
    return { header: split(lines[0]), rows: lines.slice(1).map(split) };
  }
  function cellMax(c) { var n = String(c).match(/[\d.]+/g); return n ? parseFloat(n[n.length - 1]) : NaN; }
  function toCm(c) { return String(c).replace(/[\d.]+/g, function (n) { return Math.round(parseFloat(n) * 2.54); }); }

  var FIT_STEPS = [
    { key: 'build', title: 'Which best describes your build?', options: [{ label: 'Slim', note: 'Narrow shoulders and chest', value: 0 }, { label: 'Average', note: 'Balanced proportions', value: 0 }, { label: 'Athletic', note: 'Broad chest and shoulders', value: 0.5 }, { label: 'Broad', note: 'Fuller chest or midsection', value: 1 }] },
    { key: 'fit', title: 'How do you like your jackets to fit?', options: [{ label: 'Fitted', note: 'Close to the body', value: -0.5 }, { label: 'Regular', note: 'Room to move', value: 0 }, { label: 'Relaxed', note: 'Loose and easy', value: 1.5 }] },
    { key: 'layer', title: 'What will you usually wear underneath?', options: [{ label: 'T-shirt', note: 'Light layer', value: 0 }, { label: 'Shirt or sweater', note: 'Medium layer', value: 1 }, { label: 'Hoodie or knit', note: 'Heavy layer', value: 2 }] }
  ];
  var FIT_STEPS_BOTTOM = [
    { key: 'fit', title: 'How do you like your skirt to fit?', options: [{ label: 'Fitted', note: 'Snug at the waist', value: 0 }, { label: 'Regular', note: 'A little room', value: 0.5 }, { label: 'Relaxed', note: 'Easy and comfortable', value: 1 }] }
  ];
  function recommend(rows, chestIn, answers, ease) {
    var target = chestIn + ease;
    Object.keys(answers).forEach(function (k) { target += answers[k]; });
    for (var i = 0; i < rows.length; i++) {
      if (target <= rows[i].max) { var close = rows[i].max - target < 0.5 && rows[i + 1]; return { size: rows[i].size, alt: close ? rows[i + 1].size : null }; }
    }
    return { size: null };
  }

  var built = false, hasRows = false;
  function buildGuide() {
    if (built) return;
    var table = parseTable(root.getAttribute('data-size-table'));
    if (!table) return;
    var fs = sizeFieldset();
    if (!fs) return;
    built = true;
    var tableTitle = root.getAttribute('data-size-title') || 'Size chart';
    var ease = parseFloat(root.getAttribute('data-size-ease')) || 0;
    var note = root.getAttribute('data-fit-note');
    var secondName = (root.getAttribute('data-size-second') || '').toLowerCase();
    var colName = (root.getAttribute('data-size-column') || '').toLowerCase();
    var col = 1;
    table.header.forEach(function (h, i) { if (i > 0 && h.toLowerCase() === colName) col = i; });
    var measureName = table.header[col].toLowerCase();
    var all = table.rows.map(function (r) { return { size: r[0], max: cellMax(r[col]) }; }).filter(function (r) { return !isNaN(r.max); });
    var sold = all.filter(function (r) { return radios(fs).some(function (x) { return x.value === r.size; }); });
    var rows = sold.length ? sold : all;
    if (!rows.length) rows = null;
    hasRows = !!rows;
    var rows2 = null, secondLabel = '';
    var col2 = -1;
    table.header.forEach(function (h, i) { if (i > 0 && secondName && h.toLowerCase() === secondName) col2 = i; });
    if (rows && col2 > 0) {
      var byRow = {}; table.rows.forEach(function (r) { byRow[r[0]] = cellMax(r[col2]); });
      rows2 = rows.map(function (r) { return { size: r.size, max: byRow[r.size] }; }).filter(function (r) { return !isNaN(r.max); });
      secondLabel = table.header[col2].toLowerCase();
    }
    var bottom = /waist|hip/.test(measureName);
    var steps = bottom ? FIT_STEPS_BOTTOM : FIT_STEPS;
    if (bottom) { var bn = root.getAttribute('data-fit-note-bottom'); if (bn) note = bn; }
    var bespoke = root.getAttribute('data-bespoke-eligible') === 'true';

    var tabs = [];
    if (rows) tabs.push(['fit', 'Find My Fit']);
    tabs.push(['chart', 'Size Chart'], ['measure', 'How to Measure']);
    var drawer = el('<div class="zoq-pp-drawer" role="dialog" aria-modal="true" aria-label="Size guide"><div class="zoq-pp-drawer__panel"><div class="zoq-pp-drawer__head"><strong>Size Guide</strong><button type="button" class="zoq-pp-drawer__close" aria-label="Close">&times;</button></div><div class="zoq-pp-drawer__tabs" role="tablist">' +
      tabs.map(function (t) { return '<button type="button" role="tab" data-tab="' + t[0] + '">' + t[1] + '</button>'; }).join('') +
      '</div><div class="zoq-pp-drawer__body">' + (rows ? '<div class="zoq-pp-pane" data-pane="fit"></div>' : '') + '<div class="zoq-pp-pane" data-pane="chart"></div><div class="zoq-pp-pane" data-pane="measure">' +
      (bottom ? '<ol class="zoq-pp-measure"><li><strong>Waist</strong>Measure around your natural waist, the narrowest part of your torso, keeping the tape level.</li><li><strong>Hips</strong>Stand with feet together and measure around the fullest part of your hips.</li><li><strong>Length</strong>Measure from your waist down to where you want the skirt to end.</li></ol><p class="zoq-pp-drawer__tip">Measure over light clothing and keep the tape snug but not tight.</p>'
        : '<ol class="zoq-pp-measure"><li><strong>Chest</strong>Measure around the fullest part of your chest, under the arms, keeping the tape level.</li><li><strong>Shoulders</strong>Measure from the edge of one shoulder to the other, across the top of your back.</li><li><strong>Sleeve</strong>With your arm relaxed, measure from the shoulder seam down to the wrist bone.</li><li><strong>Jacket length</strong>Measure from the base of your neck at the back down to where you want the jacket to end.</li></ol><p class="zoq-pp-drawer__tip">Measure over a T-shirt and keep the tape snug but not tight.</p>') +
      '</div></div></div></div>');
    document.body.appendChild(drawer);

    var unit = 'in';
    var chartPane = $('[data-pane="chart"]', drawer);
    function renderChart() {
      var f = unit === 'cm' ? toCm : function (v) { return v; };
      var html = '<div class="zoq-pp-unit"><span>' + tableTitle + '</span><span class="zoq-pp-unit__toggle"><button type="button" data-unit="in"' + (unit === 'in' ? ' class="is-active"' : '') + '>IN</button><button type="button" data-unit="cm"' + (unit === 'cm' ? ' class="is-active"' : '') + '>CM</button></span></div>' +
        '<div style="overflow-x:auto"><table class="zoq-pp-table"><thead><tr>' + table.header.map(function (h) { return '<th>' + h + '</th>'; }).join('') + '</tr></thead><tbody>' +
        table.rows.map(function (r) { return '<tr>' + r.map(function (c, i) { return '<td>' + (i === 0 ? c : f(c)) + '</td>'; }).join('') + '</tr>'; }).join('') + '</tbody></table></div>';
      if (note) html += '<p class="zoq-pp-drawer__tip">' + note + '</p>';
      chartPane.innerHTML = html;
      $$('[data-unit]', chartPane).forEach(function (b) { b.addEventListener('click', function () { unit = b.getAttribute('data-unit'); renderChart(); }); });
    }

    var fitPane = $('[data-pane="fit"]', drawer);
    var state = { step: 0, chest: '', chest2: '', chestUnit: 'in', answers: {} };
    var extra = rows2 ? 1 : 0;
    var total = steps.length + 1 + extra;
    function progress(n) { return '<p class="zoq-pp-fit__step">Step ' + n + ' of ' + total + '</p><div class="zoq-pp-fit__bar"><span style="width:' + Math.round(n / total * 100) + '%"></span></div>'; }
    function selectSize(size) {
      var s = sizeFieldset();
      var r = s && radios(s).filter(function (x) { return x.value === size; })[0];
      if (r && !r.checked) r.click();
      close();
    }
    function measureStep(n, label, value, optional) {
      return progress(n) + '<h3 class="zoq-pp-fit__q">What is your ' + label + ' measurement?</h3><p class="zoq-pp-drawer__tip">' + (optional ? 'Optional, but it helps us get the fit right. ' : 'Measure your body, not a ' + (bottom ? 'skirt' : 'jacket') + '. ') + 'Not sure? See <button type="button" class="zoq-pp-link" data-goto="measure">How to Measure</button>.</p>' +
        '<div class="zoq-pp-fit__chest"><input type="number" inputmode="decimal" min="10" max="160" step="0.5" placeholder="e.g. ' + (bottom ? '30' : '40') + '" aria-label="Body measurement" value="' + value + '"><span class="zoq-pp-unit__toggle"><button type="button" data-cu="in"' + (state.chestUnit === 'in' ? ' class="is-active"' : '') + '>IN</button><button type="button" data-cu="cm"' + (state.chestUnit === 'cm' ? ' class="is-active"' : '') + '>CM</button></span></div><p class="zoq-pp-fit__error" hidden>Please enter your measurement.</p><button type="button" class="zoq-pp-fit__next">Continue</button>' +
        (optional ? '<button type="button" class="zoq-pp-link" data-skip>Skip this step</button>' : '') + (state.step > 0 ? ' <button type="button" class="zoq-pp-link zoq-pp-fit__back">&larr; Back</button>' : '');
    }
    function renderFit() {
      var html, qIndex = state.step - 1 - extra;
      if (state.step === 0) html = measureStep(1, measureName, state.chest, false);
      else if (extra && state.step === 1) html = measureStep(2, secondLabel, state.chest2, true);
      else if (qIndex < steps.length) {
        var q = steps[qIndex];
        html = progress(state.step + 1) + '<h3 class="zoq-pp-fit__q">' + q.title + '</h3><div class="zoq-pp-fit__options">' + q.options.map(function (o, i) { return '<button type="button" class="zoq-pp-fit__opt" data-opt="' + i + '"><strong>' + o.label + '</strong><span>' + o.note + '</span></button>'; }).join('') + '</div><button type="button" class="zoq-pp-link zoq-pp-fit__back">&larr; Back</button>';
      } else {
        var toIn = function (v) { return state.chestUnit === 'cm' ? parseFloat(v) / 2.54 : parseFloat(v); };
        var rec = recommend(rows, toIn(state.chest), state.answers, ease);
        if (rows2 && state.chest2) {
          var rec2 = recommend(rows2, toIn(state.chest2), state.answers, ease);
          var idx = function (r) { return r.size === null ? Infinity : rows.map(function (x) { return x.size; }).indexOf(r.size); };
          if (idx(rec2) > idx(rec)) rec = rec2;
        }
        html = resultHtml(rec);
      }
      fitPane.innerHTML = html; bindFit();
    }
    function resultHtml(rec) {
      var html;
      if (rec.size) html = '<p class="zoq-pp-fit__step">Your recommended size</p><div class="zoq-pp-fit__result">' + rec.size + '</div>' + (rec.alt ? '<p class="zoq-pp-drawer__tip">You are near the top of ' + rec.size + '. For more room, choose ' + rec.alt + '.</p>' : '') + '<button type="button" class="zoq-pp-fit__next" data-select="' + rec.size + '">Select size ' + rec.size + '</button>';
      else html = '<p class="zoq-pp-fit__step">Your recommendation</p><h3 class="zoq-pp-fit__q">Your measurements are above our standard sizes.</h3>';
      if (bespoke) html += '<button type="button" class="zoq-pp-fit__alt" data-bespoke-cta>Or get it made to your measurements</button>';
      return html + '<button type="button" class="zoq-pp-link zoq-pp-fit__restart">Start again</button>';
    }
    function bindFit() {
      var input = $('input[type=number]', fitPane), field = state.step === 0 ? 'chest' : 'chest2';
      $$('[data-cu]', fitPane).forEach(function (b) { b.addEventListener('click', function () { state[field] = input.value; state.chestUnit = b.getAttribute('data-cu'); renderFit(); }); });
      var next = $('.zoq-pp-fit__next', fitPane);
      if (next && input) next.addEventListener('click', function () { var v = parseFloat(input.value); if (!v || v < 10) { $('.zoq-pp-fit__error', fitPane).hidden = false; input.focus(); return; } state[field] = input.value; state.step++; renderFit(); });
      var skip = $('[data-skip]', fitPane); if (skip) skip.addEventListener('click', function () { state.chest2 = ''; state.step++; renderFit(); });
      if (next && next.hasAttribute('data-select')) next.addEventListener('click', function () { selectSize(next.getAttribute('data-select')); });
      $$('[data-opt]', fitPane).forEach(function (b) { b.addEventListener('click', function () { var q = steps[state.step - 1 - extra]; state.answers[q.key] = q.options[+b.getAttribute('data-opt')].value; state.step++; renderFit(); }); });
      var back = $('.zoq-pp-fit__back', fitPane); if (back) back.addEventListener('click', function () { state.step--; renderFit(); });
      var restart = $('.zoq-pp-fit__restart', fitPane); if (restart) restart.addEventListener('click', function () { state = { step: 0, chest: '', chest2: '', chestUnit: 'in', answers: {} }; renderFit(); });
      var cta = $('[data-bespoke-cta]', fitPane); if (cta) cta.addEventListener('click', function () { close(); var o = $('[data-bespoke-open]'); if (o) o.click(); });
      var g = $('[data-goto]', fitPane); if (g) g.addEventListener('click', function () { showTab('measure'); });
    }
    var lastTrigger = null;
    function showTab(name) {
      $$('[data-tab]', drawer).forEach(function (t) { var on = t.getAttribute('data-tab') === name; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      $$('[data-pane]', drawer).forEach(function (p) { p.hidden = p.getAttribute('data-pane') !== name; });
    }
    function open(name, trigger) { lastTrigger = trigger; renderChart(); if (rows) renderFit(); showTab(name); drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; $('.zoq-pp-drawer__close', drawer).focus(); }
    function close() { drawer.classList.remove('is-open'); document.body.style.overflow = ''; if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus(); }
    $$('[data-tab]', drawer).forEach(function (t) { t.addEventListener('click', function () { showTab(t.getAttribute('data-tab')); }); });
    $('.zoq-pp-drawer__close', drawer).addEventListener('click', close);
    drawer.addEventListener('click', function (e) { if (e.target === drawer) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.zoq-pp-sizeguide');
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      open(b.getAttribute('data-open'), b);
    }, true);
  }

  var ruler = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="2.5" y="8" width="19" height="8" rx="1.5"/><path d="M6.5 8v3M10 8v4M13.5 8v3M17 8v4"/></svg>';
  function ensureLinks() {
    if (!built) return;
    var fs = sizeFieldset(); if (!fs) return;
    var lg = $('legend', fs); if (!lg || $('.zoq-pp-sizelinks', lg)) return;
    lg.classList.add('zoq-pp-label-row');
    var links = el('<span class="zoq-pp-sizelinks"></span>');
    if (hasRows) links.appendChild(el('<button type="button" class="zoq-pp-sizeguide" data-open="fit">' + ruler + 'Find my fit</button>'));
    links.appendChild(el('<button type="button" class="zoq-pp-sizeguide" data-open="chart">' + (hasRows ? '' : ruler) + 'Size guide</button>'));
    lg.appendChild(links);
  }

  var timer = null;
  function refresh() {
    root = $('[data-zoq-pp]'); if (!root) return;
    buildGuide(); ensureLinks(); ensureSelectedLabels(); ensureRecommended();
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 80); }
  function start() {
    refresh();
    document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('variant-picker input')) schedule(); });
    var target = $('.product-details') || document.body;
    new MutationObserver(schedule).observe(target, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
